import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DescriptionType } from 'app/main/admin/description/description-list/type';
import { DescriptionService } from 'app/services/models/description.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-description-dialog',
  templateUrl: './description-dialog.component.html',
  styleUrls: ['./description-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DescriptionDialogComponent implements OnInit {
  @Input() data: { descriptionId: null };

  descriptionForm: FormGroup;

  types: any = [];

  constructor(
    public ngbModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private descriptionType: DescriptionType,
    private descriptionService: DescriptionService) { }

  async ngOnInit() {
    this.descriptionForm = this.fb.group({
      title: [null, Validators.required],
      type: [null, Validators.required],
      description: [null, Validators.required],
      isActive: [true, Validators.required]
    });
    this.types = this.descriptionType.allType();
    if (this.data.descriptionId) {
      await this.getByIdDescription(this.data.descriptionId);
    }
  }

  async getByIdDescription(id) {
    const result = await this.descriptionService.getByIdDescription(id);
    console.log(result);
    this.descriptionForm.patchValue({
      title: result.title,
      type: result.type,
      description: result.content,
      isActive: result.isActive
    });
  }

  close(result?: any) {
    this.ngbModal.close(result);
  }

  async save() {
    const formValue = this.descriptionForm.value;
    const typeData = this.types.find((type) => type.id === formValue.type);

    // isSingle bilgisi tipi üzerinden geliyor
    const formData = {
      ...formValue,
      isSingle: typeData?.isSingle ?? false,
    };

    let response;

    if (this.data.descriptionId) {
      formData.id = this.data.descriptionId;
      response = await this.descriptionService.updateDescription(formData);
    } else {
      response = await this.descriptionService.createDescription(formData);
    }

    if (response.status) {
      this.toastrService.success(response.message);
      this.close(true);
    } else {
      this.toastrService.error(response.message);
    }
  }

}
